import React, { useEffect } from 'react';
import { ToastItem } from '../../contexts/ToastContext';
import '../../styles/components/Toast.css';

interface ToastProps {
  toast: ToastItem;
  onClose: (id: string) => void;
}

const Toast: React.FC<ToastProps> = ({ toast, onClose }) => {
  useEffect(() => {
    if (toast.duration && toast.duration > 0) {
      const timer = setTimeout(() => {
        onClose(toast.id);
      }, toast.duration);
      return () => clearTimeout(timer);
    }
  }, [toast.id, toast.duration, onClose]);

  return (
    <div className={`toast toast-${toast.type || 'info'}`}>
      <div className="toast-message">{toast.message}</div>
      <button 
        className="toast-close" 
        onClick={() => onClose(toast.id)}
        aria-label="Close"
      >
        ×
      </button>
    </div>
  );
};

export default Toast;

